import React, { Suspense, lazy, useEffect, useContext, useRef, useState } from 'react'
import Landing from '../../Components/Landing/Landing'
import Navbar from '../../Components/NavBar/Navbar'
import { ThemeContext } from '../../Components/Context/Context';
import './Main.css'

const About = lazy(() => import('../../Components/About/About'))
const Skills = lazy(() => import('../../Components/Skills/Skills'))
const Projects = lazy(() => import('../../Components/Projects/Projects'))
const Research = lazy(() => import('../../Components/Research/Research'))
const Experience = lazy(() => import('../../Components/Experience/Experience'))
const Achievements = lazy(() => import('../../Components/Achievements/Achievements'))
const Education = lazy(() => import('../../Components/Education/Education'))
const Testimonials = lazy(() => import('../../Components/Testimonials/Testimonials'))
const Footer = lazy(() => import('../../Components/Footer/Footer'))

const LazySection = ({ id, children, minHeight = '720px' }) => {
  const sectionRef = useRef(null)
  const [shouldRender, setShouldRender] = useState(false)

  useEffect(() => {
    if (shouldRender) return undefined

    if (!('IntersectionObserver' in window)) {
      setShouldRender(true)
      return undefined
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShouldRender(true)
          observer.disconnect()
        }
      },
      { rootMargin: '520px 0px' }
    )

    if (sectionRef.current) {
      observer.observe(sectionRef.current)
    }

    return () => observer.disconnect()
  }, [shouldRender])

  return (
    <section
      ref={sectionRef}
      id={id}
      className={`lazy-portfolio-section ${shouldRender ? 'is-ready' : ''}`}
      style={{ minHeight }}
    >
      {shouldRender ? (
        <Suspense fallback={<SectionLoader />}>{children}</Suspense>
      ) : (
        <SectionLoader />
      )}
    </section>
  )
}

const SectionLoader = () => (
  <div className="section-loader" aria-label="Loading portfolio section">
    <span></span>
    <span></span>
    <span></span>
  </div>
)

const Main = () => {
  const { darkMode } = useContext(ThemeContext);
  useEffect(() => {
    document.body.classList.toggle('dark-mode', darkMode);
    document.body.dataset.theme = darkMode ? 'dark' : 'light';
  }, [darkMode]);
  return (

    <main className={`portfolio-shell ${darkMode ? 'dark' : 'light'}`}>
    <Navbar/>
    <Landing/>
    <LazySection id="aboutsection"><About/></LazySection>
    <LazySection id="skillsection"><Skills/></LazySection>
    <LazySection id="projectsection"><Projects/></LazySection>
    <LazySection id="researchsection"><Research/></LazySection>
    <LazySection id="experiencesection"><Experience/></LazySection>
    <LazySection id="achievementsection"><Achievements/></LazySection>
    <LazySection id="educationsection"><Education/></LazySection>
    <LazySection id="testimonialsection" minHeight="560px"><Testimonials/></LazySection>
    <LazySection id="contactsection" minHeight="760px"><Footer/></LazySection>
    </main>

  )
}

export default Main
